export default function FooterSection() {
  return (
    <footer className="w-full bg-gray-900 text-white py-14 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div>
            <p className="text-white font-bold text-base tracking-wide mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>
              INTEROSMO P.C.
            </p>
            <p className="text-white/40 text-xs leading-6 max-w-xs" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
              iOS application development experts building secure, high-performance mobile apps for modern users.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
            <div>
              <p className="text-white/30 text-xs uppercase tracking-widest mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>Address</p>
              <p className="text-white/70 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>6 Pefkon Metamorfosi</p>
            </div>
            <div>
              <p className="text-white/30 text-xs uppercase tracking-widest mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>Location</p>
              <p className="text-white/70 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>City: Attikis</p>
              <p className="text-white/70 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>Zip: 14451</p>
              <p className="text-white/70 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>Country: Greece</p>
            </div>
            <div>
              <p className="text-white/30 text-xs uppercase tracking-widest mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>Contact</p>
              <p className="text-white/70 text-xs mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>Email: info@interosmopc.com</p>
              <p className="text-white/70 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>Number: +1 2295081216</p>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-white/30 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; {new Date().getFullYear()} INTEROSMO P.C. All rights reserved.
          </p>
          <p className="text-white/20 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            iOS App Development &mdash; Greece
          </p>
        </div>
      </div>
    </footer>
  );
}
